import { Select, WrapItem, useBreakpointValue, FormControl, FormLabel, SimpleGrid, FormHelperText } from '@chakra-ui/react';
import { Field, useFormikContext } from 'formik';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
const timeListFrom = [8, 12];
const timeListTo = [12, 16];
const timeListComeback = [8, 12];

const getDaysInMonth = (year, month) => {
	if (year == null || month === '' || month == null) return 31;
	return new Date(year, month + 1, 0).getDate();
};

const DateTimeFormField = ({ name, value, label, required, from = false, to = false, comeback = false }) => {
	const { setFieldValue } = useFormikContext();
	const { t } = useTranslation();
	const showSmallScreen = useBreakpointValue({ base: true, sm: true, md: false });
	const showLargeScreen = useBreakpointValue({ base: false, sm: false, md: true });

	const currentYear = new Date().getFullYear();
	const initialDate = value instanceof Date ? value : null;

	const [day, setDay] = useState(initialDate ? initialDate.getDate() : '');
	const [month, setMonth] = useState(initialDate ? initialDate.getMonth() : '');
	const [year, setYear] = useState(initialDate ? initialDate.getFullYear() : currentYear);
	const [hour, setHour] = useState(initialDate ? initialDate.getHours() : '');
	const [isToBeConfirmed] = useState(false);

	useEffect(() => {
		const allFieldsEmpty = !day && !month && !year && !hour;
		const allFieldsFilled = day !== '' && month !== '' && year !== '' && hour !== '';

		if (isToBeConfirmed) {
			setFieldValue(name, null);
		} else if (allFieldsEmpty) {
			setFieldValue(name, null);
		} else if (allFieldsFilled) {
			const d = new Date(year, month, day, hour);
			setFieldValue(name, isNaN(d.getTime()) ? null : d);
		} else {
			setFieldValue(name, null);
		}
	}, [year, month, day, hour, isToBeConfirmed, name, setFieldValue]);

	const selectProps = {
		style: { borderRadius: '3px' },
		size: 'sm',
	};

	return (
		<Field name={name}>
			{({ meta }) => (
				<FormControl mb={4} mt={8} id={name} isInvalid={meta.touched && meta.error}>
					{label && (
						<FormLabel>
							{label} {required && <span style={{ color: 'red' }}>*</span>}
						</FormLabel>
					)}

					<SimpleGrid columns={showLargeScreen ? 5 : showSmallScreen ? 3 : 1} spacing={3} mb={2}>
						{/* DAY */}
						<WrapItem width="85px">
							<Select placeholder="Day" value={day} onChange={(e) => setDay(parseInt(e.target.value))} {...selectProps}>
								{Array?.from({ length: getDaysInMonth(year, month) }).map((_, i) => (
									<option key={i + 1} value={i + 1}>
										{i + 1 < 10 ? `0${i + 1}` : i + 1}
									</option>
								))}
							</Select>
						</WrapItem>

						{/* MONTH */}
						<WrapItem width="85px">
							<Select placeholder="Month" value={month} onChange={(e) => setMonth(parseInt(e.target.value))} {...selectProps}>
								{months?.map((m, i) => (
									<option key={m} value={i}>
										{m}
									</option>
								))}
							</Select>
						</WrapItem>

						{/* YEAR */}
						<WrapItem width="85px">
							<Select value={year} onChange={(e) => setYear(parseInt(e.target.value))} {...selectProps}>
								{[currentYear, currentYear + 1]?.map((yr) => (
									<option key={yr} value={yr}>
										{yr}
									</option>
								))}
							</Select>
						</WrapItem>

						{/* TIME (FROM) */}
						{from && (
							<WrapItem width="85px">
								<Select
									placeholder="HH"
									value={hour}
									isRequired={required}
									onChange={(e) => setHour(parseInt(e.target.value))}
									{...selectProps}
								>
									{timeListFrom?.map((h) => (
										<option key={h} value={h}>
											{h}:00
										</option>
									))}
								</Select>
							</WrapItem>
						)}

						{/* TIME (TO) */}
						{to && (
							<WrapItem width="85px">
								<Select
									placeholder="HH"
									value={hour}
									isRequired={required}
									onChange={(e) => setHour(parseInt(e.target.value))}
									{...selectProps}
								>
									{timeListTo?.map((h) => (
										<option key={h} value={h}>
											{h}:00
										</option>
									))}
								</Select>
							</WrapItem>
						)}

						{/* TIME (COMEBACK) */}
						{comeback && (
							<WrapItem width="85px">
								<Select
									placeholder="HH"
									value={hour}
									isRequired={required}
									onChange={(e) => setHour(parseInt(e.target.value))}
									{...selectProps}
								>
									{timeListComeback?.map((h) => (
										<option key={h} value={h}>
											{h}:00
										</option>
									))}
								</Select>
							</WrapItem>
						)}
					</SimpleGrid>

					{meta.touched && meta.error && (
						<FormHelperText id="error-message-password" color="red.400" fontSize="12px">
							{t(name)}&nbsp;{t('is')}&nbsp;{t(meta.error)}
						</FormHelperText>
					)}
				</FormControl>
			)}
		</Field>
	);
};

export default DateTimeFormField;
